<template>
  <div class="bg">
    <div class="home-container">
      <div class="px-6 flex flex-col lg:flex-row">
        <div class="lg:w-1/2 order-2 lg:order-1 ">
          <div class="flex justify-center px-12">
            <a target="_blank" href="https://effectnode.com">
              <img src="../../assets/images/effectnode-webby.png" alt="">
            </a>
          </div>
          <div class="flex justify-center px-12">
            <a target="_blank" href="https://igraph.effectnode.com">
              <img src="../../assets/images/igraph-w3.png" alt="">
            </a>
          </div>
          <div class="pt-3 text-gray-500">
            EffectNode got Nominated for <a target="_blank" class="underline" href="https://www.webbyawards.com/winners/2019/websites/features-design/technical-achievement/effectnodecom/">Webby's Website Technology Achivement</a> in 2019.
            iGraph got <a target="_blank" class="underline" href="https://www.w3award.com/winners/list/view/?search=iGraph&event=1031&award=2">W3 Award Silver </a> in 2019.
          </div>
          <div class="h-16"></div>
        </div>
        <div class="lg:w-1/2 lg:order-2">
          <div class="lg:px-12">
            <div class=" font-title font-bold text-xl tracking-tight text-blue-500">
              Created with ❤️ by Lok Lok
            </div>
            <div class="py-4 font-title font-black text-5xl tracking-tighter leading-none text-black">
              Utilisting Award Winning Web Inventions
            </div>
            <div class="text-lg text-gray-700">
              “Practicing Composing Technology is a way to improve my thinking. EffectNode and iGraph are one of the my favourite invetions, my coding practices and discovery for inspiration.”
            </div>
            <div class="font-title text-lg text-black mt-5">
              Lok Lok
            </div>
            <div class="text-md text-gray-500">
              A <a target="_blank" class="underline" href="https://www.iadas.net/membership/bio/lok-wong/7842">Webby’s Judge</a> & Creative Technologist at <a target="_blank" class="underline" href="https://effectnode.com">EffectNode.com</a>
            </div>
            <div class="h-8 lg:h-16"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="postcss">
</style>
